import config from "../api/config";

const { apiBaseUrl } = config;

const validateAuthentication = ({ status }: Response) => {
  if (status === 401) {
    window.location.reload();
    throw new Error("Unauthenticated");
  }
};

export const get = async (url: string) => {
  const response = await fetch(`${apiBaseUrl}/${url}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  validateAuthentication(response);
  return response;
};

export const post = async (url: string, data: object) => {
  const response = await fetch(`${apiBaseUrl}/${url}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  validateAuthentication(response);
  return response;
};
